export default {
  'slide.pro.title.remote-connection': {
    id: 'slide.pro.title.remote-connection',
    defaultMessage: 'Remote connection',
  },
  'slide.pro.text.remote-connection': {
    id: 'slide.pro.text.remote-connection',
    defaultMessage: "Connect to your customers' myUplink compatible devices and start monitoring them remotely.",
  },
  'slide.pro.title.monitor': {
    id: 'slide.pro.title.monitor',
    defaultMessage: "Help check the status of your customers' systems, spot faults and keep them secure.",
  },
  'slide.pro.text.monitor': {
    id: 'slide.pro.text.monitor',
    defaultMessage: "Help check the status of your customers' systems, spot faults and keep them secure.",
  },
  'slide.pro.title.find-and-contact': {
    id: 'slide.pro.title.find-and-contact',
    defaultMessage: 'Quickly look up your customers, get directions and contact them when you need to.',
  },
  'slide.pro.text.find-and-contact': {
    id: 'slide.pro.text.find-and-contact',
    defaultMessage: 'Quickly look up your customers, get directions and contact them when you need to.',
  },
  'slide.pro.title.get-the-app': {
    id: 'slide.pro.title.get-the-app',
    defaultMessage: 'Part of your smart home. Download the app today to take advantage of all the features.',
  },
  'slide.pro.text.get-the-app': {
    id: 'slide.pro.text.get-the-app',
    defaultMessage: 'Part of your smart home. Download the app today to take advantage of all the features.',
  },
  'slide.text.works-with-simple': {
    id: 'slide.text.works-with-simple',
    defaultMessage: 'myUplink PRO works with a number of products.',
  },
  'slide.pro.text.works-with': {
    id: 'slide.pro.text.works-with',
    defaultMessage: 'myUplink works with a number of smart home services and products.',
  },
  'slide.title.works-with': {
    id: 'slide.title.works-with',
    defaultMessage: 'Works with',
  },
  'slide.button.works-with': {
    id: 'slide.button.works-with',
    defaultMessage: 'Works with myUplink',
  },
  'unauth.menu.developer': {
    id: 'unauth.menu.developer',
    defaultMessage: 'Developers',
  },
  'unauth.menu.professional': {
    id: 'unauth.menu.professional',
    defaultMessage: 'Professionals',
  },
  'unauth.menu.private': {
    id: 'unauth.menu.private',
    defaultMessage: 'Consumers',
  },
  'slide.alt.works-with.alt': {
    id: 'slide.alt.works-with.alt',
    defaultMessage: 'Company logo with whom we work',
  },
};
